import http from '../../services/httpService';

const apiEndpoint = '/v4/status/';

export const getStatus = async () => await http.get(apiEndpoint);
